import React, { useState, useEffect } from 'react';
import axios from '../services/api';

const EmployerDashboard = () => {
  const [jobs, setJobs] = useState([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [salary, setSalary] = useState('');

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get('/jobs');
        setJobs(response.data.jobs);
      } catch (err) {
        console.error('Error fetching jobs:', err);
      }
    };
    fetchJobs();
  }, []);

  const handlePostJob = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/jobs', { title, description, location, salary });
      alert('Job posted successfully!');
      setTitle('');
      setDescription('');
      setLocation('');
      setSalary('');
    } catch (err) {
      console.error('Error posting job:', err);
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-center text-royal-blue mb-6">Employer Dashboard</h1>

      {/* Post a Job */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-royal-blue mb-4">Post a Job</h2>
        <form onSubmit={handlePostJob}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2" htmlFor="title">
              Title
            </label>
            <input
              type="text"
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-cyan"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2" htmlFor="description">
              Description
            </label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-cyan"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2" htmlFor="location">
              Location
            </label>
            <input
              type="text"
              id="location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-cyan"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2" htmlFor="salary">
              Salary
            </label>
            <input
              type="number"
              id="salary"
              value={salary}
              onChange={(e) => setSalary(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-cyan"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-cyan text-white py-2 rounded-lg hover:bg-blue-700"
          >
            Post Job
          </button>
        </form>
      </div>

      {/* Posted Jobs */}
      <div>
        <h2 className="text-2xl font-bold text-royal-blue mb-4">Posted Jobs</h2>
        <ul>
          {jobs.length > 0 ? (
            jobs.map((job) => (
              <li key={job.id} className="mb-2">
                <p>{job.title} - {job.location}</p>
              </li>
            ))
          ) : (
            <p>No jobs posted yet.</p>
          )}
        </ul>
      </div>
    </div>
  );
};

export default EmployerDashboard;